import { gql } from "@apollo/client"
import { DEPENDENT_FIELDS } from "./DependentFields"
import { MONEY_FIELDS } from "~/shared/fragments/MoneyFields"

export const DEPENDENT_ENROLLMENT_FIELDS = gql`
  ${DEPENDENT_FIELDS}
  ${MONEY_FIELDS}
  fragment DependentEnrollmentFields on BenefitsDependentEnrollment {
    id
    state
    externalId
    coverageEndDate
    enrolledAt
    cancelledAt
    availableEvents
    coverageStartDate
    cancellationReason
    recommendedEmployerContribution
    currentPrice {
      employerContribution {
        ...MoneyFields
      }
    }
    dependent {
      ...DependentFields
    }
    pricePaidProvider {
      ...MoneyFields
    }
    enrollmentPrices {
      collection {
        id
        effectiveDate
        employerContribution {
          ...MoneyFields
        }
        pricePaidProvider {
          ...MoneyFields
        }
      }
    }
  }
`
